/*
 * Public API Surface of ngx-lib/textbox
 */
export * from './textbox.module';
export * from './textbox.component';
